import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KnowledgeExpertiseRoutingModule } from './knowledge-expertise-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { KnowledgeExpPageComponent } from './components/knowledge-exp-page/knowledge-exp-page.component';
import { AdminKnowledgeExpComponent } from './components/admin-knowledge-exp/admin-knowledge-exp.component';


@NgModule({
  declarations: [ KnowledgeExpPageComponent, AdminKnowledgeExpComponent],
  imports: [
    CommonModule,
    KnowledgeExpertiseRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class KnowledgeExpertiseModule { }
